import { Component, computed, input } from '@angular/core';
import { CoreService } from 'src/app/services/core/core.service';

interface StepperNode {
  id: number;
  titleKey: string;
}

// Maps the order status codes returned by the API to the matching stepper step
const ORDER_STATUS_STEP_MAP: Record<string, number> = {
  'AWAITING_APPROVAL': 1,
  'APPROVED': 2,
  'ORDER_ACTIVE': 3,
  'DELIVERY_BOOKED': 4,
  'DELIVERED': 5,
};

@Component({
  selector: 'app-completed-quote-stepper',
  templateUrl: './completed-quote-stepper.component.html',
  styleUrls: ['./completed-quote-stepper.component.scss'],
  standalone: false
})

export class CompletedQuoteStepperComponent {

  constructor(private coreService: CoreService) { }

  readonly orderStatus = input<string>('');

  readonly currentStep = computed(() => ORDER_STATUS_STEP_MAP[this.orderStatus().toUpperCase().trim()] ?? 1);

  steps: StepperNode[] = [
    { id: 1, titleKey: 'STEPPER_AWAITING_APPROVAL' },
    { id: 2, titleKey: 'STEPPER_QUOTE_APPROVED' },
    { id: 3, titleKey: 'STEPPER_ORDER_IN_PROGRESS' },
    { id: 4, titleKey: 'STEPPER_DELIVERY_BOOKED' },
    { id: 5, titleKey: 'STEPPER_DELIVERED' }
  ];

  get isMobileView(): boolean {
    return this.coreService.isMobileApp || (typeof window !== 'undefined' && window.innerWidth <= 768);
  }
}
